import {
  ToggleInlineStyle
} from './inline-style'

export class Bold extends ToggleInlineStyle {
  getInlineStyle = () => 'BOLD'

  getButtonText = () => 'B'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/inline-style/bold.js
 **/